export var ActionType = /*#__PURE__*/ function (ActionType) { ActionType["Failed"] = "Failed"; return ActionType; }({});
